import { formatMoney, toMoney } from '@betterment/js-runtime';
import { Box, Button, Dialog, Heading, IconButton, ListRow, Separator, Text } from '@betterment/samba-react';

type Props = {
  balance: number;
  pendingInflowAmount: number;
};

export const AccountBalanceIconWithModal = ({ balance, pendingInflowAmount }: Props) => {
  return (
    <Dialog>
      <Dialog.Trigger asChild={true}>
        <IconButton name="InfoCircle" label="account balance details" spacing="none" variant="ghostSecondary" />
      </Dialog.Trigger>
      <Dialog.Content css={{ p: 'space.400', width: '50%' }}>
        <Dialog.Title>
          <Heading>Account balance</Heading>
        </Dialog.Title>
        <Separator css={{ width: '100%' }} />
        <Box css={{ display: 'flex', flexDirection: 'column' }}>
          <Dialog.Description>
            <ListRow css={{ width: '100%', px: '0' }}>
              <ListRow.LeadingContent>
                <Text>Total balance</Text>
              </ListRow.LeadingContent>
              <ListRow.TrailingContent>
                <Text variant="text100">{formatMoney(toMoney(balance))}</Text>
              </ListRow.TrailingContent>
            </ListRow>
            <Separator css={{ width: '100%' }} />
            <ListRow css={{ width: '100%', px: '0' }}>
              <ListRow.LeadingContent>
                <Text>Pending deposits</Text>
              </ListRow.LeadingContent>
              <ListRow.TrailingContent>
                <Text variant="text100">
                  {pendingInflowAmount > 0 ? '+' : ''}
                  {formatMoney(toMoney(pendingInflowAmount))}
                </Text>
              </ListRow.TrailingContent>
            </ListRow>
          </Dialog.Description>
        </Box>
        <Separator css={{ width: '100%' }} />
        <Dialog.Close asChild={true}>
          <Button variant="solidSecondary" css={{ mt: 'space.300' }}>
            Close
          </Button>
        </Dialog.Close>
      </Dialog.Content>
    </Dialog>
  );
};
